<template>
  <div class="j_page_layout_builder_svg__" :id='localId'>
    <component 
      v-for="(svg, i) in chartItems"
      v-bind="vBinds[svg.ChartNo]"
      :key="svg.index"
      :getSelectItems ="getSelectItems"
      :ref="`__ref__chart_item_${i}___${localId}`"
      :id="`__chart_item_${i}___${localId}`"
      :is="CAT_CODE_CHART_COMPONENT(svg.CatCode, svg)"
      :movable="false"
      :chart-type="svg.ChartType"
      :filter-values="filters"
      :filters="filters"
      :callback="callback"
      @complete="(v) => onComplete(v, svg)"
      @request-action="(v) => onRequestedAction(v, svg)"
      @request-procedure="(v) => onRequestedProc(v,svg, i)"
      @resize="onResized"
      @selectedItems="selectedItems"
      @exportItems="exportItems"
    />
  </div>
</template>
<script>
import '@/assets/stylus/ui/component/_jDashboardLayoutBuilder.scss'

import __C from '@/primitives/_constant_'
import { SafeIdMixin } from '@/mixins/safeid.mixin'
import JSvgChartNComponents from '@/components/JLibChartComponents'
import { mapState, mapGetters } from "vuex"
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default {
  name: 'j-page-layout-builder-svg',
  inject: ['ExportSvg'],
  mixins: [
    SafeIdMixin
  ],
  components: {
    ...JSvgChartNComponents
  },
  props: {
    mode: { type: String, default: 'layout' },
    chartMetaSupply: { type: Object, default: () => ({}) },
    chartItems: { type: Array, default: () => ([]) },
    chartItemUpdated: { type: Object, default: () => ({}) },
    filters: { type: Object, default: () => ({}) },
    callback: { type: Object, default: () => ({}) },
  },
  data: () => ({
    vBinds: {},
    dimention: {},
    inlineOptions: { inlineStyles: true, inlineImages: true },
    pendingProc: {},
  }),
  computed: {
    ...mapGetters(__C.STORE_NAMESPACE.APP_SERVICE, [
      'getSelectItems'
    ]),
    __C_() { return __C },
  },
  watch: {
    chartItems: { 
      handler(val) {
        if(!val) return

        this.$nextTick(() => {
          this.onChartItemsChanged()
        })
      }, 
      deep: true 
    },
  },
  created() {
    this.localId = this.id || 'j-page-layout-builder__' + this.safeId('')
  },
  mounted() {
    // LNB에서 버튼클릭시 실행할 핸들러를 등록
    this._exportSvgHandler = (title) => this.exportPageAsSVG(title)
    this.ExportSvg && this.ExportSvg.setExportSvgHandler && this.ExportSvg.setExportSvgHandler(this._exportSvgHandler)
  },
  beforeUnmount() {
    this.ExportSvg && this.ExportSvg.clearExportSvgHandler && this.ExportSvg.clearExportSvgHandler(this._exportSvgHandler)
  },
  methods: {
    CAT_CODE_CHART_COMPONENT(catCode, chart) {
      let componentName__ = {
        HIS: () => 'JLibChartHistogram',
        SKY: () => 'JLibChartSkyline',
        TSM: () => 'JLibChartTableSummary',
        LIBSVGTB: (chart) => this.getCustomComponent(chart),
        LIBSVGPG: (chart) => this.getCustomComponent(chart)
      }
      return componentName__[catCode](chart)
    },
    onChartItemsChanged() {
      let vBinds__ = {}

      this.chartItems.forEach((item_, i) => {
          let props_ = this.setChartPropsData(item_, i)
          // if([
          //   __C.CHART.CAT_CODE_CUSTOM,
          //   __C.CHART.CAT_CODE_COMPLIB_SVG_CHART_CONTROLLER,
          //   __C.CHART.CAT_CODE_COMPLIB_SVG_NAVIGATION,
          //   __C.CHART.CAT_CODE_COMPLIB_SVG_TAB,
          //   __C.CHART.CAT_CODE_COMPLIB_SVG_PAGE,
          //  ].includes(item_.catCode)) props_.FilterValues = this.filters

          vBinds__[item_.ChartNo] = props_
      })

      this.vBinds = vBinds__
    },
    onComplete(v, svg) { 
      this.$emit('complete', { id: v, chart: svg }) 
    },
    onRequestedAction(request, pagesvg) {
      let props_ = pagesvg.JsonProps ? JSON.parse(pagesvg.JsonProps) : null
      let prop_ = props_ ? props_.find(prop => prop.export) : null
      let export_ = prop_ ? prop_.export : null

      this.$emit('request-action', {
        export: export_,
        parent: {
          ...pagesvg.ActionAttrs
        },
        sender: {
          ...request
        }
      })
    },

    onRequestedProc(request, svg, index) {
      const requestId = request && request.requestId
        ? request.requestId
        : `${this.localId}_EXCEL_EXPORT_PROC`

      const refName = `__ref__chart_item_${index}___${this.localId}`
      this.pendingProc[requestId] = {
        refName,
        index,
      }
      console.log('builder onRequestedProc', requestId, request, this.pendingProc)
      this.$emit('request-procedure', request )
    },

    retProcResponse(ret) {
      if (!ret || !ret.requestId) return
      console.log('builder retProcResponse', ret)

      const entry = this.pendingProc[ret.requestId]
      const refName = entry && entry.refName
      const ref_ = refName ? this.$refs[refName] : null
      const inst = Array.isArray(ref_) ? ref_[0] : ref_

      if (inst) {
        if (typeof inst.onCallbackSvg === 'function') {
          console.log('builder retProcResponse call onCallbackSvg', ret)
          inst.onCallbackSvg(ret)
        }
      }

      delete this.pendingProc[ret.requestId]
    },
    onRequestEmpty(req) {
      this.$emit('empty-check', req)
    },
    onResized(d) {
      this.dimention = d
      this.$emit('resize', d)
    },
    exportItems(items) {
      this.$emit('exportItems', items)
    },
    selectedItems(items) {
      this.$emit('selectedItems', items)
    },    
    parseJsonProps(chart) {
      return chart.JsonProps ? JSON.parse(chart.JsonProps) : []
    },
    extractDataItems(chart) {
      let dataItem_ = (
        chart.QApplied == __C.DATABASE.QUERY_APPLIED_JSON ? 
        (chart.JsonString ? JSON.parse(chart.JsonString) : []) :
        (chart.QResultSummary ? chart.QResultSummary : [])
      )

      return dataItem_
    },
    extractData(chart, typeName) {
      // check the data one column attributes (attributes-in-a-column type)
      if(chart[typeName]) return chart[typeName]

      let keyNames = Object.keys(chart).filter(k => k.toLowerCase().indexOf(typeName.toLowerCase()) === 0)
      let data = {}
      keyNames.forEach(k => { data[k] = chart[k] })

      return data
    },
    extractStyleStatus(chart) {
      return chart.StyleAttrs ? chart.StyleAttrs : chart.Status
    },
    extractValue(chart) {
      if(chart.CatCode == __C.CHART.CAT_CODE_DONUT) return chart.Values

      let keyNames = Object.keys(chart).filter(k => k.toLowerCase().indexOf('value') === 0)
      let data = {}
      keyNames.forEach(k => { data[k] = chart[k] })

      return data
    },
    extractSqlValues(chart) {
      let values_ = { 
        milestone: (
          chart.MilestoneQApplied == 'J' ? 
          (chart.MilestoneQJson ? JSON.parse(chart.MilestoneQJson) : []) : 
          chart.QResultMilestone
        ), 
        // note: '2019-11-01' // deprecated
      }
      // sql-result 'Note' is changed to Title Sql, and its result 
      // is stored in a specified column 'TitleSqlText' at the point
      // of getting the chart data.
      return values_
    },
    findData(chart, attrName, default_) {
      return chart[attrName] || default_
    },
    findTabAttributes(chart, el) {
      return chart.TabAttrs ? chart.TabAttrs[el] : {}
    },
    getCustomComponent(chart) {
      return chart.UrlEntrance
    },
    setChartPropsData(chart_, i) {
      let ref_ = `__ref__chart_item_${i}___${this.localId}`
      // Why undefined ?, Why .$options undefined... ????? Check it...
      if(!this.$refs[ref_]) return null  
      if(typeof this.$refs[ref_][0] == 'undefined') return null
      // if(typeof this.$refs[ref_][0].$options == 'undefined') return null 
      if(typeof this.$refs[ref_][0]._.propsOptions[1] == 'undefined') return null 
      let props__ = {
        ColumnProps : () => this.parseJsonProps(chart_)                                     , 
        DataItems   : () => this.extractDataItems(chart_)                                   ,
        Queries     : () => this.findData(chart_, __C.CHART.ATTR_NAME_Q_RESULT_EXTRAS, {})  ,
        Axis        : () => this.extractData(chart_, __C.CHART.ATTR_NAME_AXIS)              ,
        AxisY       : () => this.extractData(chart_, __C.CHART.ATTR_NAME_AXIS)              ,
        Bar         : () => this.extractData(chart_, __C.CHART.ATTR_NAME_BAR)               ,
        Boxes       : () => this.extractData(chart_, __C.CHART.ATTR_NAME_BOXES)             ,
        Canvas      : () => this.extractData(chart_, __C.CHART.ATTR_NAME_CANVAS)            ,
        Circle      : () => this.extractData(chart_, __C.CHART.ATTR_NAME_CIRCLE)            ,
        Compare     : () => this.extractData(chart_, __C.CHART.ATTR_NAME_COMPARE)           ,
        Delta       : () => this.extractData(chart_, __C.CHART.ATTR_NAME_DELTA)             ,
        Guideline   : () => this.extractData(chart_, __C.CHART.ATTR_NAME_GUIDELINE)         ,
        Legends     : () => this.extractData(chart_, __C.CHART.ATTR_NAME_LEGENDS)           ,
        Line        : () => this.extractData(chart_, __C.CHART.ATTR_NAME_LINE)              ,
        Milestone   : () => this.extractData(chart_, __C.CHART.ATTR_NAME_MILESTONE)         ,
        Note        : () => this.extractData(chart_, __C.CHART.ATTR_NAME_NOTE)              ,
        Package     : () => this.extractData(chart_, __C.CHART.ATTR_NAME_PACKAGE)           ,
        Timeline    : () => this.extractData(chart_, __C.CHART.ATTR_NAME_TIMELINE)          ,
        Status      : () => this.extractStyleStatus(chart_)                                 ,
        Value       : () => this.extractValue(chart_)                                       ,
        Values      : () => this.extractSqlValues(chart_)                                   ,
        Text        : () => this.findData(chart_, __C.CHART.ATTR_NAME_TEXT, {})             ,
        Table       : () => this.findData(chart_, __C.CHART.ATTR_NAME_TABLE, {})            ,
        Styles      : () => this.findData(chart_, __C.CHART.ATTR_NAME_STYLE, [])            ,
        Columns     : () => this.findData(chart_, __C.CHART.ATTR_NAME_COLUMNS, [])          ,
        Header      : () => this.findData(chart_, __C.CHART.ATTR_NAME_HEADER, [])           ,
        Footer      : () => this.findData(chart_, __C.CHART.ATTR_NAME_FOOTER, [])           ,
        Border      : () => this.findData(chart_, __C.CHART.ATTR_NAME_BORDER, [])           ,
        ChartData   : () => this.findData(chart_, __C.CHART.ATTR_NAME_CHARTDATA, [])        ,
        ModalDraw   : () => this.findTabAttributes(chart_, 'draw')                          ,
        ModalTaps   : () => this.findTabAttributes(chart_, 'tabs')                          ,
        TabStatus   : () => this.findData(chart_, __C.CHART.ATTR_NAME_TAB_STATUS, [])       ,
        Common      : () => this.findData(chart_, __C.CHART.ATTR_NAME_CHTCOMM, {})          , 
        CTypes      : () => this.findData(chart_, __C.CHART.ATTR_NAME_CHTTYPE, {})          , 
        DataCols    : () => this.findData(chart_, __C.CHART.ATTR_NAME_CHTCOL, {})           , 
        JQueries    : () => this.findData(chart_, __C.CHART.ATTR_NAME_JQUERIES, {})         ,
      }
      let propKeys__ = Object.keys(props__)
      let propData_ = {}
      // this.$refs[ref_][0].$options._propKeys.forEach(k => {
      this.$refs[ref_][0]._.propsOptions[1].forEach(k => {
        if(propKeys__.indexOf(k) < 0) return
        propData_[k] = props__[k]()
      })
      return propData_
    },
    async exportPageAsSVG(title='pageSVG') {
      const root = this.$el
      const svg_wrapper = root.querySelectorAll('.svg_wrapper ')

      const zip = new JSZip()
      const folder = zip.folder(this.slugify(title))

      let fileCount = 0

      for (let s = 0; s < svg_wrapper.length; s++) {
        const sec = svg_wrapper[s]

        // 섹션 하위의 모든 SVG (아이콘/버튼 제외 필요시 필터)
        const allSvgs = Array.from(sec.querySelectorAll('svg')).filter(svg => {
          if (svg.closest('.v-btn,.v-icon,.mdi,.v-overlay,[data-ignore-export]')) return false
          try { const b = svg.getBBox(); if (!b || b.width===0 || b.height===0) return false } catch(e) {
            if ((svg.offsetWidth||0)===0 && (svg.offsetHeight||0)===0) return false
          }
          return true
        })

        for (let i = 0; i < allSvgs.length; i++) {
          const svgEl = allSvgs[i]
          const svgString = await this.serializeSVG(svgEl, this.inlineOptions)
          const fname = `chart_${i+1}.svg`
          folder.file(fname, svgString)   // 텍스트로 추가
          fileCount++
        }
      }

      if (!fileCount) {
        console.log('No SVG to export in pageSVG')
        return
      }

      const blob = await zip.generateAsync({ type: 'blob' })
      saveAs(blob, `${this.slugify(title)}.zip`)
    },
    // async exportPageAsSVG(title) {
    //   const svgs = this.$el.querySelectorAll('.svg_wrapper svg')
    //   if (!svgs.length) {
    //     console.log('Not found SVG in dashboard')
    //     return
    //   }

    //   let idx = 1
    //   const pageTitle = title || 'pageSvg'
    //   for (const svgEl of svgs) {
    //     const svgString = await this.serializeSVG(svgEl, this.inlineOptions)
    //     this.downloadSVG(`${pageTitle}_${idx}.svg`, svgString)
    //     idx++
    //   }
    // },
    // SVG serialize Utils
    async serializeSVG(svgEl, { inlineStyles = true, inlineImages = true } = {}) {
      const clone = svgEl.cloneNode(true)
      
      clone.setAttribute('version', '1.1')
      clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
      clone.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink')

      clone.removeAttribute('x')
      clone.removeAttribute('y')

      const rect = (typeof svgEl.getBBox === 'function')
        ? svgEl.getBBox()
        : svgEl.getBoundingClientRect()

      const vb = svgEl.getAttribute('viewBox')
      let width  = parseFloat(svgEl.getAttribute('width'))  || (vb ? +vb.split(/\s+/)[2] : rect.width)  || svgEl.clientWidth  || 1200
      let height = parseFloat(svgEl.getAttribute('height')) || (vb ? +vb.split(/\s+/)[3] : rect.height) || svgEl.clientHeight || 800

      width  = Math.max(1, Math.round(width))
      height = Math.max(1, Math.round(height))

      if (!clone.getAttribute('viewBox')) {
        clone.setAttribute('viewBox', `0 0 ${width} ${height}`)
      } else {
        const parts = clone.getAttribute('viewBox').trim().split(/\s+/)
        if (parts.length === 4 && (parts[0] !== '0' || parts[1] !== '0')) {
          clone.setAttribute('viewBox', `0 0 ${parts[2]} ${parts[3]}`)
        }
      }

      clone.setAttribute('width',  String(width))
      clone.setAttribute('height', String(height))
      
      if (inlineStyles) this.inlineStylesRecursive(clone)
      if (inlineImages) await this.inlineImages(clone)

      const xml = new XMLSerializer().serializeToString(clone)
      return `<?xml version="1.0" encoding="UTF-8"?>\n` + xml
    },
    inlineStylesRecursive(el) {
      const win = el.ownerDocument.defaultView
      const style = win.getComputedStyle(el)
      const cssText = Array.from(style).map(p => `${p}:${style.getPropertyValue(p)}`).join(';')
      if (cssText) el.setAttribute('style', cssText)

      if (style.fill) el.setAttribute('fill', style.fill)
      if (style.stroke) el.setAttribute('stroke', style.stroke)
      if (style.font) el.setAttribute('font', style.font)
      if (style.fontFamily) el.setAttribute('font-family', style.fontFamily)
      if (style.fontSize) el.setAttribute('font-size', style.fontSize)

      for (const child of el.children) this.inlineStylesRecursive(child)
    },
    async inlineImages(svgEl) {
      const imgEls = svgEl.querySelectorAll('image, img')
      for (const img of imgEls) {
        const href = img.getAttribute('href') || img.getAttribute('xlink:href')
        if (!href || href.startsWith('data:')) continue
        try {
          const res = await fetch(href, { mode: 'cors' })
          const blob = await res.blob()
          const dataUrl = await new Promise(resolve => {
            const fr = new FileReader()
            fr.onload = () => resolve(fr.result)
            fr.readAsDataURL(blob)
          })
          img.removeAttribute('href')
          img.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', dataUrl)
        } catch (e) {
          console.log('Fail Inline Image:', href, e)
        }
      }
    },
    slugify(t) {
      return String(t).trim().toLowerCase()
        .replace(/\s+/g,'-').replace(/[^\w\-]+/g,'').replace(/\-+/g,'-')
    },
    downloadSVG(filename, svgString) {
      const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' })
      const a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = filename.endsWith('.svg') ? filename : filename + '.svg'
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(a.href)
      a.remove()
    }
  }
}
</script>
